import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withPanorama } from '@wix/yoshi-flow-editor';
import PlayerWrapper from './player-wrapper';
import { handleVideoEndMobile } from '../../redux/actions/handle-video-end';
import {
  isPlayRequested,
  isPauseRequested,
  isPlaying,
  isPaused,
  isPlayAborted,
  isPlayingOptimistic,
  isPausedOptimistic,
  isMuted,
} from '../../selectors/playback';
import {
  abortPlay,
  setPaused,
  setPlaying,
  setEnded,
  setMuted,
  setInitial,
  requestPlayAction,
} from '../../redux/reducers/playback';

const mapStateToProps = (state, { videoItem: { id } }) => ({
  isVideoPlayRequested: isPlayRequested(state, id),
  isVideoPauseRequested: isPauseRequested(state, id),
  isVideoPlaying: isPlaying(state, id),
  isVideoPaused: isPaused(state, id),
  isVideoPlayingOptimistic: isPlayingOptimistic(state, id),
  isVideoPausedOptimistic: isPausedOptimistic(state, id),
  isVideoPlayAborted: isPlayAborted(state, id),
  isMuted: isMuted(state),
});

const mapDispatchToProps = (dispatch, { panoramaClient }) => ({
  handleVideoEnd: () => dispatch(handleVideoEndMobile(panoramaClient)),
  abortPlayVideo: (id) => dispatch(abortPlay(id)),
  setPaused: (id) => dispatch(setPaused(id)),
  setPlaying: (id) => dispatch(setPlaying(id)),
  setEnded: (id) => dispatch(setEnded(id)),
  setMuted: (muted) => dispatch(setMuted(muted)),
  setInitial: (id) => dispatch(setInitial(id)),
  requestPlay: (muted) => dispatch(requestPlayAction(muted)),
});

const ConnectedMobilePlayer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class MobilePlayer extends React.Component {
    static propTypes = {
      overlay: PropTypes.any,

      width: PropTypes.number,
      height: PropTypes.number,
      currentTime: PropTypes.number,

      preload: PropTypes.string,
      mainOrThumbnailLocation: PropTypes.string,

      videoUrls: PropTypes.object,
      videoItem: PropTypes.object,
      channelData: PropTypes.object,
      size: PropTypes.object,
      currentSiteUser: PropTypes.object,
      appSettings: PropTypes.object,

      abortPlay: PropTypes.func,
      onFullScreenChanged: PropTypes.func,
      onEnded: PropTypes.func,
      fetchVideoUrls: PropTypes.func,
      onPause: PropTypes.func,
      onMemberSignUp: PropTypes.func,
      onSubscribeClick: PropTypes.func,
      onPurchaseClick: PropTypes.func,
      onRentClick: PropTypes.func,
      setPaused: PropTypes.func,
      setPlaying: PropTypes.func,
      setEnded: PropTypes.func,
      fetchVideoCards: PropTypes.func,
      onPlayRequest: PropTypes.func,
      cleanupVideoCards: PropTypes.func,
      handleVideoEnd: PropTypes.func,
      setAutoPlayed: PropTypes.func,
      setPlaybackStatus: PropTypes.func,

      muted: PropTypes.bool,
      loop: PropTypes.bool,
      showInitialOverlay: PropTypes.bool,
      isVideoCardsEnabled: PropTypes.bool,
      shouldLoadVideo: PropTypes.bool,
      canShowChannelCover: PropTypes.bool,
      isOverQuota: PropTypes.bool,
      isLive: PropTypes.bool,
      simple: PropTypes.bool,
      isInLightbox: PropTypes.bool,
      isAutoplayed: PropTypes.bool,
      isVideoPlayRequested: PropTypes.bool,
      isVideoPauseRequested: PropTypes.bool,
      isVideoPlaying: PropTypes.bool,
      isVideoPaused: PropTypes.bool,
      isVideoPlayingOptimistic: PropTypes.bool,
      isVideoPausedOptimistic: PropTypes.bool,
      isVideoPlayAborted: PropTypes.bool,
      isMuted: PropTypes.bool,
    };

    static defaultProps = {
      onEnded: _.noop,
      onPlayStart: _.noop,
    };

    onPlayStart = () => {
      const {
        setPlaying,
        videoItem: { id },
        onPlayStart,
      } = this.props;

      setPlaying(id);

      onPlayStart();
    };

    onPause = () => {
      const {
        setPaused,
        videoItem: { id },
      } = this.props;

      setPaused(id);
    };

    onPlayBlocked = () => {
      const {
        setMuted,
        videoItem: { id },
        requestPlay,
      } = this.props;

      setMuted(true);
      requestPlay(id);
    };

    onResume = () => {
      const {
        setPlaying,
        videoItem: { id },
      } = this.props;

      setPlaying(id);
    };

    onEnded = () => {
      const {
        setEnded,
        videoItem: { id },
        onEnded,
      } = this.props;

      setEnded(id);
      onEnded();
    };

    onLoad = () => {
      const {
        videoItem: { id },
        setInitial,
      } = this.props;
      setInitial(id);
    };

    render() {
      const props = _.omit(this.props, 'mobileMode', 'playInline');

      return (
        <PlayerWrapper
          {...props}
          onPlayBlocked={this.onPlayBlocked}
          onPlayStart={this.onPlayStart}
          onPause={this.onPause}
          onResume={this.onResume}
          onEnded={this.onEnded}
          onLoad={this.onLoad}
          mobileMode
          playAtFullScreen={false}
          playInline
        />
      );
    }
  },
);

export default withPanorama(ConnectedMobilePlayer);
